// import gsap
import gsap from "gsap";

// import scrollTrigger
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Canon type switching functionality
const canonButtons = document.querySelectorAll("[data-type]");
const canonPathWrapper = document.getElementById("canon-path");
const canonLinearWrapper = document.getElementById("canon-linear");

// Initialize with path visible
if (canonPathWrapper && canonLinearWrapper) {
  canonPathWrapper.classList.remove("hidden");
  canonLinearWrapper.classList.remove("active");

  // Set initial button state
  canonButtons.forEach((button) => {
    if (button.dataset.type === "path") {
      button.classList.add("active");
    } else {
      button.classList.remove("active");
    }
  });
}

// Handle button clicks
canonButtons.forEach((button) => {
  button.addEventListener("click", () => {
    const type = button.dataset.type;

    // Update button states
    canonButtons.forEach((btn) => btn.classList.remove("active"));
    button.classList.add("active");

    // Toggle canon types
    if (type === "path") {
      canonPathWrapper.classList.remove("hidden");
      canonLinearWrapper.classList.remove("active");
    } else if (type === "linear") {
      canonPathWrapper.classList.add("hidden");
      canonLinearWrapper.classList.add("active");
    }
  });
});

const canonItems = document.querySelectorAll(".canon--item");

canonItems.forEach((item) => {
  gsap.from(item, {
    opacity: 0,
    y: 100,
    duration: 0.5,
    scrollTrigger: {
      trigger: item,
      start: "top bottom",
      end: "top 20%",
      scrub: true,
    },
  });
});

// Animate canon path items with staggered effect based on row position
const canonPathRows = document.querySelectorAll(".canon-path-row");
canonPathRows.forEach((row, rowIndex) => {
  const items = row.querySelectorAll(".canon-path-item");

  items.forEach((item, itemIndex) => {
    // Stagger in DOM order; CSS controls visual direction for even rows
    const staggerIndex = itemIndex;
    const xOffset = 100;

    gsap.from(item, {
      opacity: 0,
      x: xOffset,
      duration: 0.6,
      delay: staggerIndex * 0.1, // Stagger delay
      ease: "power2.out",
      scrollTrigger: {
        trigger: row,
        start: "top 80%",
        end: "top 20%",
        toggleActions: "play none none reverse",
      },
    });
  });
});
